<template>
    <div class="search-container">
      <div class="top-search">
        <div class="left-search">
          <van-search class="search-input" v-model="searchValue" @input="searchValueChange" placeholder="输入产品名称" />
        </div>
        <div class="right-btn">
          <van-button class="search-btn" type="info" @click="clickSearch">搜索</van-button>
        </div>
      </div>
      <div class="search-content" v-show="showSearchKey">
        <div class="search-mask-container" v-show="searchValue">
          <div class="search-mask">
            <p v-show="searchHint.length == 0">没有搜索到数据</p>
            <p @click="resultEvent(item)" v-for="(item,index) in searchHint" :key="index">{{item.title}}</p>
          </div>
        </div>
        <div class="search-recommend">
          <h3 class="search-tit">搜索推荐</h3>
          <div class="list">
            <div class="item" @click="resultEvent(item)" v-for="(item,index) in hotTitle" :key="index">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="search-result" v-if="showResult" ref="activity_scroll" @scroll="activityScroll">
        <div class="product-content-container" v-if="productList.length != 0">
          <div class="item">
            <div class="item-bottom">
              <div class="option" @click="goProductDetails(item)" v-for="(item,index) in productList" :key="index">
                <div class="img-cover">
                  <img :src="cdnUrl+item.cover_img" alt="" class="img">
                </div>
                <div class="product-title">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-data" v-if="productList.length == 0">
          <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">
          <p class="hint-text">暂无产品</p>
        </div>
      </div>
    </div>
</template>

<script>
// import { hideMenuItems } from '@/libs/wxjssdk'
import { searchProductTitle, getProductHotTitle, getProductList } from '@/api/product'
import { debounce } from '@/libs/util'
import { wxShare } from '@/libs/wxjssdk'
export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            searchValue: '', // 搜索的值
            showSearchKey: true, // 搜索提示是否显示
            showResult: false, // 搜索结果列表是否显示
            searchHint: [], // 搜索提示列表
            hotTitle: [], // 热门标题列表
            productList: [] // 产品数据
        }
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    created () {
        // hideMenuItems(['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:share:facebook', 'menuItem:share:QZone', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari'])
        this.getProductHotTitlePort()
    },
    mounted () {
        this.sharePage()
    },
    methods: {
        sharePage () {
            var link = window.location.href.split('#')[0]
            const params = {
                title: 'Eppendorf 产品商城', // 分享标题
                desc: 'Eppendorf 产品商城', // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            // console.log('打印参数', params)
            wxShare(params)
        },
        // 上拉触底
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 150 // 距离底部距离
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                console.log('上拉触底了')
            }
        },
        // 单击了搜索结果
        resultEvent (item) {
            console.log(item)
            this.getProductListPort(item)
            this.showSearchKey = false
            this.showResult = true
        },
        // 搜索框数据发生变化
        searchValueChange (val) {
            this.showSearchKey = true
            this.showResult = false
            this.searchProductTitlePort()
        },
        // 单击搜索
        clickSearch () {
            this.showSearchKey = false
            this.showResult = true
            this.getProductListPort({ title: this.searchValue })
        },
        // 单击产品，跳转详情
        goProductDetails (item) {
            console.log(item)
            this.$router.push(
                {
                    name: 'productDetails',
                    query: {
                        id: item.id || ''
                    }
                }
            )
        },
        /** 网络请求 **/
        // 根据产品名称搜索
        searchProductTitlePort: debounce(function () {
            var params = {
                search: this.searchValue
            }
            searchProductTitle(params).then(res => {
                if (res.errCode === 0) {
                    if (res.data.length >= 15) {
                        var spliceData = [...res.data]
                        spliceData = spliceData.splice(0, 15)
                        this.searchHint = spliceData
                    } else {
                        this.searchHint = res.data
                    }
                }
            }).catch(err => {
                console.log('获取产品名称搜索提示失败', err)
            })
        }, 500),
        // 获取热门搜索标题
        getProductHotTitlePort () {
            getProductHotTitle().then(res => {
                if (res.errCode === 0) {
                    if (res.data.length >= 10) {
                        var hotTitle = [...res.data]
                        hotTitle = hotTitle.splice(0, 10)
                        this.hotTitle = hotTitle
                    } else {
                        this.hotTitle = res.data
                    }
                }
            }).catch(err => {
                console.log('获取热门搜索标题失败', err)
            })
        },
        // 根据产品名称获取产品
        getProductListPort (item) {
            var params = {
                search: item.title
            }
            getProductList(params).then(res => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.productList = data.data
                }
            }).catch(err => {
                console.log('获取产品失败', err)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
  @import "./scss/product";
.search-container{
  display: flex;
  flex-direction: column;
  height: 100vh;
  .top-search{
    display: flex;
    align-items: center;
    padding-left: rem(10);
    padding-right: rem(18);
    .left-search{
      width: 80%;
      position: relative;
      padding: 0 rem(10);
      .van-search{
        padding-left: 0;
        padding-right: 0;
      }
      .van-search .van-cell,.van-search__content{
        background: #f0f0f0;
      }
    }
    .right-btn{
      width: 20%;
      .search-btn{
        width: 100%;
        background: $base-color;
        border-color: #6cc4da;
        height: rem(30);
        line-height: rem(30);
      }
    }
  }
  .search-content{
    .search-mask-container{
      width: 80%;
      padding-left: rem(20);
      padding-right: rem(22);
      margin-top: rem(-5);
      position: relative;
      z-index: 9;
      .search-mask{
        padding: rem(5) rem(12);
        background: #f0f0f0;
        color: #4d4d4d;
        font-size: 13px;
        line-height: rem(26);
      }
    }
    .search-recommend{
      padding: 0 rem(20);
      font-size: rem(14);
      font-weight: normal;
      margin-top: rem(8);
      .search-tit{
        height: rem(30);
        line-height: rem(30);
      }
      .list{
        &:after{
          content: '';
          clear: both;
          display: block;
        }
        .item{
          width: 50%;
          float: left;
          line-height: rem(25);
          color: #4d4d4d;
          font-size: 13px;
          padding-right: rem(15);
        }
      }
    }
  }
  .search-result{
    margin-top: rem(10);
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .product-content-container{
      padding-top: rem(20);
    }
    .no-data{
      width: 60%;
      display: block;
      margin: 0 auto;
      text-align: center;
      color: #b1acac;
      font-size: rem(13);
      padding-bottom: rem(10);
      .hint-text{
        margin: rem(10) 0;
      }
    }
  }
}
</style>
